import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Auth } from "@angular/fire/auth";
import { from, Observable } from "rxjs";
import { mergeMap } from "rxjs/operators";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private readonly auth = inject(Auth);

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.auth.currentUser) {
            return next.handle(req);
        }

        return from(this.auth.currentUser.getIdToken()).pipe(
            mergeMap((token) => {
                const headers = req.headers.set("id-token", token);
                const authReq = req.clone({ headers });

                return next.handle(authReq);
            })
        );
    }
}
